import { useFeatureFlag } from 'configcat-react';

import { MAINTENANCE } from '../toggles';

export function useMaintenanceModeEnabled() {
    const { value: isMaintenanceModeEnabled } = useFeatureFlag(MAINTENANCE, false);
    return Boolean(isMaintenanceModeEnabled);
}
